export default __webpack_public_path__ + "static/media/ChangeNumber-SecureTextEnabled.73e3eda9.png";